import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

export const submitIntake = (data) => client.post("/intake", data).then((r) => r.data);
export const submitReferral = (data) => client.post("/referral", data).then((r) => r.data);
export const submitContact = (data) => client.post("/contact", data).then((r) => r.data);

export const createDonationCheckout = (data) => client.post("/payments/checkout", data).then((r) => r.data);
export const getPaymentStatus = (sessionId) => client.get(`/payments/status/${sessionId}`).then((r) => r.data);
export const getReferralStatus = (refId) => client.get(`/referral/${encodeURIComponent(refId)}`).then((r) => r.data);
export const getDonationStats = () => client.get("/donations/stats").then((r) => r.data);
export const getDonorWall = () => client.get("/donations/wall").then((r) => r.data);
export const getManageInfo = (token) => client.get(`/donations/manage/${token}`).then((r) => r.data);
export const pauseGift = (token) => client.post(`/donations/manage/${token}/pause`).then((r) => r.data);
export const resumeGift = (token) => client.post(`/donations/manage/${token}/resume`).then((r) => r.data);
export const cancelGift = (token) => client.post(`/donations/manage/${token}/cancel`).then((r) => r.data);
export const updateGiftAmount = (token, amount) => client.post(`/donations/manage/${token}/update`, { amount }).then((r) => r.data);

export default client;
